import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=05aa658a&scoped=true&"
import script from "./Calls.vue?vue&type=script&lang=ts&"
export * from "./Calls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aa658a",
  null
  
)

export default component.exports